import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const GroupContainer = styled.div``;

export const GroupTitle = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  margin: 5px 0px;
  overflow-x: hidden;
`;

export const GroupSubtitle = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  margin: 5px 0px;
  max-width: 500px;
`;

export const GroupDate = styled.p`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  white-space: nowrap;
`;

export const GroupAuthor = styled.p`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 0;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const GroupParameterList = styled.div`
  padding: 20px 20px 30px;
  display: grid;
  grid-template-columns: 1fr 1fr 86px;
  column-gap: 20px;
`;

export const EmptyGroupBannerContainer = styled.div`
  padding: 20px 20px 0;
`;

export const GroupFooter = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
`;

export const GroupFooterRight = styled.div`
  display: flex;
  column-gap: 20px;
`;
